import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { logOutApp } from '../GlobalModules/Login/Actions/LoginAction';
import NotFoundPage from '../GlobalModules/Utility/Pages/NotFound';
import Header from '../GlobalModules/Utility/Components/Header'
import Footer from '../GlobalModules/Utility/Components/Footer';
import Sidebar from '../GlobalModules/Utility/Components/Sidebar';
import FAB from '../GlobalModules/Utility/Components/FAB/FAB'
import Utility from '../GlobalModules/Utility/Utility'
import { faPlus, faShoppingCart, faBox, faUsers, faBell, faUtensils, faConciergeBell, faUserPlus, faFileInvoice, faMoneyBillWave, faShoppingBag, faFileContract, faCalendarPlus } from '@fortawesome/free-solid-svg-icons';
import './Auth.scss';
import { Link, useParams, withRouter, useLocation } from 'react-router-dom';

const AuthLayout = (props) => {
  const { lng } = useParams();
  const location = useLocation();
  const { userCredentials, logOutApp, history, allowedRoles } = props;
														  

  // Permission helper function
  const hasPermission = (userType, roleKey, index, eventKey, allowedRules) => {
    if (userType === 'admin') return true;
    const role = Utility.getRoleObjectByEventKey(roleKey);
    if (!role || !role.subeventKey || role.subeventKey.length <= index) return false;
    const sub = role.subeventKey[index];
    return sub.eventKey === eventKey && allowedRules.includes(sub.rules);
  };

  const userType = userCredentials?.user_details?.user_type;

  //initially check user credentials are valid or not
  useEffect(() => {
    checkForUSerCrendentials()
  }, [])

  //user credentials checking and redirection fn
  const checkForUSerCrendentials = () => {
    if (props.token == undefined || props.token == '') {
      history.push('/')
			 
    }
    if (!props.token || props.token === "" || !allowedRoles.includes(userCredentials.user_details.user_type)) {
      history.push("/not-found")
							  
			  
									   
    }
  }

  //======= add action permission ====//
  // Check multiple permissions at once
  const ordersPermissions = Utility.hasMultipleActionPermissions(
    'sales_and_orders',
    'orders',
    ['view', 'create', 'edit', 'delete', 'export', 'approve', 'receive', 'generate_invoice', 'change_status', 'accept', 'reject', 'KOT info', 'cancel', 'bill', 'bill_post', 'cancel_bill_post', 'invoice'],
    props.userCredentials?.user_details?.user_type
  );

  const productPermissions = Utility.hasMultipleActionPermissions(
    'stock',
    'products',
    ['view', 'create', 'edit', 'delete', 'export', 'manage_variants', 'manage_addons', 'manage_ingredients', 'upload_images', 'delete_images', 'generate_barcode', 'product_audit_history', 'add_stock'],
    props.userCredentials?.user_details?.user_type || ['admin', 'app_admin']
  );
  const isCostCenterWithSell = props.currentStore?.store_type === 'COST_CENTER' && props.currentStore?.can_sell;

  const hasOrderCreationAbility = () => {
    return (props.currentStore?.store_type === 'BRANCH' && !props.currentStore?.is_procurement_hub) || (props.currentStore?.store_type === 'COST_CENTER' && props.currentStore?.can_sell);
  };

  return (
    <>
      {props.token &&
        props.token !== '' &&
        allowedRoles.includes(userCredentials.user_details.user_type) ?
        <div className={`app-layout${props.currentStore?.is_procurement_hub ? ` store-theme-${(props.currentStore?.store_type || 'COST_CENTER').toLowerCase()}` : ''}`}>
          <Header history={props.history} />

          {/* Subscription Expired Message */}
          {Utility.isSubscriptionExpired(userCredentials) && (
            <div className="subscription-expired-alert">
              {Utility.getSubscriptionStatusMessage(userCredentials)}
            </div>
          )}

          <div className='app-container app-container-main'>
            <Sidebar history={props.history} props={props} />
            <div
              className={`main-content-wrapper ${props.leftbar ? 'sidebar-collapsed' : ''
                }`}
            >
              <main className={`main-content main-content-box ${location.pathname.includes('/restaurant/kitchen-display') ||
                location.pathname.includes('/sales/orders/add')
                ? 'special-layout-class'
                : location.pathname.includes('/reports/night-audit-report') ? 'night-audit-report-layout-class' : location.pathname.includes("/dashboard/v2") ? 'dashboard-v2-layout-class' : ''
                }`}>
                {props.children}
              </main>
              <Footer />
            </div>
          </div>
        </div>
        :
        <NotFoundPage permission={false} history={props.history} />
      }
      {(() => {
        const newOrderVisible = !Utility.isSubscriptionExpired(userCredentials) && (['admin'].includes(userType) || (Object.keys(Utility.getRoleObjectByEventKey('sales_and_orders')).length > 0 && hasPermission(userType, 'sales_and_orders', 2, 'orders', ['CRUD', 'CUD']))) && ordersPermissions.create;
        const newProductVisible = !Utility.isSubscriptionExpired(userCredentials) && (['admin'].includes(userType) || (Object.keys(Utility.getRoleObjectByEventKey('stock')).length > 0 && hasPermission(userType, 'stock', 0, 'products', ['CRUD', 'CUD']))) && productPermissions.create;

        if (!newOrderVisible && !newProductVisible) {
          return null;
        }

        return (
          <FAB
            icon={faPlus}
            tooltip="Quick Actions"
            color="primary"
            position="bottom-right"
            direction="up"
            options={[
              {
                component: <Link to={`/${lng}/sales/orders/add`} />,
                icon: faShoppingCart,
                tooltip: 'New Order',
                color: 'primary',
                isVisible: newOrderVisible && hasOrderCreationAbility()
              },
              {
                component: <Link to={`/${lng}/stock/products/add`} />,
                icon: faBox,
                tooltip: 'New Product',
                color: 'warning',
                isVisible: newProductVisible
              },
            ]}
          />
        );
      })()}
    </>
  )
}

const mapStateToProps = (globalState) => {
  return {
    leftbar: globalState.mainReducerData.leftbar,
    userCredentials: globalState.LoginReducer.userCredentials,
    token: globalState.LoginReducer.token,
    currentStore: globalState.StoreReducer.currentStore
  }
}

export default connect(mapStateToProps, { logOutApp })(withRouter(AuthLayout));